import Vue from 'vue';
import qwest from 'qwest';
import AwesomePicker from 'vue-awesome-picker';

import App from './App.vue';
import router from './router';
import store from './store';
import { DatetimePicker, Popup, Button } from 'vant';


import 'vant/lib/index.css';


import './registerServiceWorker';

const md5Fn = require('blueimp-md5');

qwest.setDefaultDataType('json');

window.env = 'common';
window.isDebug = false;
window.qwest = qwest;
if (window.location.href.indexOf('http://mys4s.cn') !== -1) {
  qwest.base = 'http://mys4s.cn/';
} else if (window.location.href.indexOf('https://mys4s.cn') !== -1) {
  qwest.base = 'https://mys4s.cn/';
} else {
  window.isDebug = true;
  window.env = 'common'; // 调试配置  cmblife 招商  alipay  支付宝   wechat  微信   baiduapp  百度  common  综合   cmbapp 招商银行app
  // qwest.base = 'http://test.mys4s.cn/';
  // qwest.base = 'https://dev.mys4s.cn/'; // 上线时候的路径
  // qwest.base ='http://cdev.mys4s.cn/';  //测试环境，一般测试用不了
  qwest.base = 'http://mys4s.cn/'; // 线上环境，改代码时候用，但是上线时切回到上面路径
}
// qwest.base = ""
Vue.config.productionTip = false;

const signData = (data, path) => {
  const array = [];
  let key;
  const seed = '99754106633f94d350db34d548d6091a';
  for (key in data) {//eslint-disable-line
    if (data[key] !== undefined) {
      array.push(`${key}=${data[key]}`);
    }
  }
  array.sort();
  let param = '';
  for (const item of array) {//eslint-disable-line
    if (param !== '') {
      param += '&';
    }
    param += item;
  }
  param += seed;
  param += path.substring(0, 1) === '/' ? path : (`/${path}`);
  // console.log(param)
  return md5Fn(param);
};
class Modal {
  constructor() {
    const modal = document.createElement('div');
    const modalBg = document.createElement('div');
    const modalBox = document.createElement('div');
    const modalTitle = document.createElement('h4');
    const modalContent = document.createElement('div');
    const modalButton = document.createElement('div');
    const modalConfirmButton = document.createElement('div');
    const modalCancelButton = document.createElement('div');
    // 设置style
    modal.setAttribute('class', 'modal');
    modalBg.setAttribute('class', 'modal-bg');
    modalBox.setAttribute('class', 'modal-box');
    modalTitle.setAttribute('class', 'modal-main modal-main-title');
    modalContent.setAttribute('class', 'modal-main modal-main-content');
    modalButton.setAttribute('class', 'modal-button');
    modalConfirmButton.setAttribute('class', 'modal-confirm-button');
    modalCancelButton.setAttribute('class', 'modal-confirm-cancel');

    document.body.appendChild(modal);
    modal.appendChild(modalBg);
    modal.appendChild(modalBox);
    modalBox.appendChild(modalTitle);
    modalBox.appendChild(modalContent);
    modalBox.appendChild(modalButton);
    modalButton.appendChild(modalConfirmButton);
    modalButton.appendChild(modalCancelButton);

    modal.style.zIndex = -1;

    this.modal = modal;
    this.modalBox = modalBox;
    this.modalTitle = modalTitle;
    this.modalContent = modalContent;
    this.modalButton = modalButton;
    this.modalConfirmButton = modalConfirmButton;
    this.modalCancelButton = modalCancelButton;
  }
}
class Toast extends Modal {
  constructor(props) {
    super(props);
    this.timer = null;
    this.toast = null;
    this.loading = null;
    this.showToast = this.showToast.bind(this);
    this.hideToast = this.hideToast.bind(this);
    this.showModal = this.showModal.bind(this);
  }
  showToast({ title = '', duration = 2500 }) {
    if (this.timer && this.toast) {
      document.body.removeChild(this.toast);
      clearTimeout(this.timer);
      this.timer = null;
      this.toast = null;
    }
    this.toast = document.createElement('div');
    this.toast.className = 'toast';
    //
    this.toast.innerHTML = title;
    //
    document.body.appendChild(this.toast);
    this.timer = setTimeout(() => {
      clearTimeout(this.timer);
      this.timer = null;
      document.body.removeChild(this.toast);
    }, duration);
  }
  hideToast() {
    if (this.toast) document.body.removeChild(this.toast);
    clearTimeout(this.timer);
    this.timer = null;
  }
  showLoading() {
    console.log('showLoading', this.loading);
  }
  hideLoading() {
    console.log('hideLoading', this);
  }
  showModal({
    title, content, confirmFn, confirmText = '确定', cancelText, cancelFn,
  }) {
    this.modalTitle.innerHTML = title;
    this.modalContent.innerHTML = content;
    if (cancelText) {
      this.modalCancelButton.innerHTML = cancelText;
      this.modalCancelButton.style.display = 'inherit';
    } else {
      this.modalCancelButton.style.display = 'none';
    }
    this.modalConfirmButton.innerHTML = confirmText;
    this.modalCancelButton.onclick = () => {
      this.modal.style.zIndex = '-1';
      this.modalBox.style.transform = '0';
      setTimeout(() => {
        this.modalTitle.innerHTML = '';
        this.modalContent.innerHTML = '';
        this.modalCancelButton.innerHTML = '';
        this.modalConfirmButton.innerHTML = '';
        if (cancelFn) cancelFn();
      }, 250);
    };
    this.modalConfirmButton.onclick = () => {
      this.modal.style.zIndex = '-1';
      this.modalBox.style.opacity = '0';
      setTimeout(() => {
        this.modalTitle.innerHTML = '';
        this.modalContent.innerHTML = '';
        this.modalCancelButton.innerHTML = '';
        this.modalConfirmButton.innerHTML = '';
        if (confirmFn) confirmFn();
      }, 250);
    };
    this.modal.style.zIndex = '999';
    this.modalBox.style.opacity = '1';
  }
}
const toastClass = new Toast();
/*eslint-disable */
const MyHttpPlugin = {
  install(Vue, options) {
    Vue.prototype.$showLoading = toastClass.showLoading,
      Vue.prototype.$hideLoading = toastClass.hideLoading,
      Vue.prototype.$showToast = toastClass.showToast,
      Vue.prototype.$hideToast = toastClass.hideToast,
      Vue.prototype.$showModal = toastClass.showModal,
      Vue.prototype.$params = (param = {}) => Object.keys(param).map(key => `${key}=${param[key]}`).join('&');
    Vue.prototype.$request = (path, params = {}) => {
      const t = (new Date()).getTime();
      let channel = 'h5'
      try {
        if (window.localStorage.viochannel) {
          channel = window.localStorage.viochannel || 'h5'
        }
      } catch (e) {
      }
      const np = {
        ...params,
        t,
        access_token: store.getters.token || '',
        channel,
      };

      for (const key in np) {
        const val = np[key];
        if (typeof val === 'number') {
          np[key] = `${val}`;
        }
      }
      const md5 = signData(np, path);
      np.md5 = md5;
      const req = Object.keys(np).map((key) => {
        if (np[key] !== undefined) {
          return `${key}=${encodeURIComponent(np[key])}`;
        }
        return '';
      }).join('&');
      return qwest.get(`${path}?${req}`, null, {
        cache: true,
        withCredentials: true,
      });
    };
    Vue.prototype.$requestPost = (path, params = {}) => {
      const t = (new Date()).getTime();
      const np = {
        ...params,
        t,
        access_token: store.getters.token || '',
        channel: 'h5'
      };
      try {
        if (window.localStorage.viochannel) {
          np.channel = window.localStorage.viochannel || 'h5'
        }
      } catch (e) {
      }
      for (const key in np) {
        const val = np[key];
        if (typeof val === 'number') {
          np[key] = `${val}`;
        }
      }
      const md5 = signData(np, path);

      np.md5 = md5;
      return qwest.post(`${path}`, np, {
        cache: true,
        withCredentials: true,
      });
    };
  },
};
/* eslint-enable */
Vue.use(MyHttpPlugin);
Vue.use(AwesomePicker);
// 日期对象
Vue.use(DatetimePicker);
Vue.use(Popup);
Vue.use(Button);

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});


new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
